import React from 'react';
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
} from '@mui/material';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import PeopleIcon from '@mui/icons-material/People';
import BedIcon from '@mui/icons-material/Bed';

import roomImage1 from '../../images/card1.jpg';
import roomImage2 from '../../images/hillside.jpg';
import roomImage3 from '../../images/kataluoya.jpg';

function Accommodations() {
  const accommodations = [
    {
      title: 'Dawatagala Chalet',
      size: '420 Sqf',
      guests: 'Upto 4 Guests',
      bed: '2 Super King Size Beds',
      image: roomImage1,
      description: `Enhance your stay with a range of carefully curated amenities designed for comfort and convenience. Take a refreshing dip in your private plunge pool, enjoy a warm cup from the in-room tea and coffee-making facilities, or unwind in a cozy reading corner with your favorite book. Stay entertained with satellite TV and a selection of classic board games, or stay connected effortlessly with complimentary high-speed Wi-Fi throughout your stay. Every detail is crafted to make your experience truly memorable.`,
    },
    {
      title: 'Knuckles Hillside Chalet',
      size: '320 Sqf',
      guests: 'Upto 3 Guests',
      bed: '1 King Size Bed and 1 rollaway beds',
      image: roomImage2,
      description: `Relax and recharge with an array of thoughtfully chosen amenities. Soak in the comfort of a luxurious bathtub, savor a hot beverage with in-room tea and coffee making facilities, or curl up in your cozy reading corner with a good book. Stay entertained with satellite TV and a variety of board games, or stay connected with free high-speed Wi-Fi. Every detail is designed to ensure your comfort and convenience, making your stay truly memorable.`,
    },
    {
      title: 'Katuloya Chalet',
      size: '420 Sqf',
      guests: 'Upto 4 Guests',
      bed: '1 Super King Size Bed and 2 rollaway beds',
      image: roomImage3,
      description: `Enhance your stay with a range of carefully curated amenities designed for comfort and convenience. Take a refreshing dip in your private plunge pool, enjoy a warm cup from the in-room tea and coffee-making facilities, or unwind in a cozy reading corner with your favorite book. Stay entertained with satellite TV and a selection of classic board games, or stay connected effortlessly with complimentary high-speed Wi-Fi throughout your stay. Every detail is crafted to make your experience truly memorable.`,
    },
  ];

  return (
    <Box sx={{ backgroundColor: '#fff', color: '#000', py: 6 }}>
      <Container>
        {/* Header */}
        <Typography
          variant="h4"
          sx={{ fontWeight: 'bold', textAlign: 'center', mb: 1 }}
        >
          Elegant Accommodations
        </Typography>
        <Typography
          variant="h5"
          sx={{ textAlign: 'center', fontWeight: 'bold', mb: 5 }}
        >
          Designed for Comfort and Luxury
        </Typography>

        {/* Card Section */}
        <Grid container spacing={4}>
          {accommodations.map((room, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  boxShadow: 3,
                  borderRadius: '8px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={room.image}
                  alt={room.title}
                />
                <CardContent>
                  {/* Title */}
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 'bold', mb: 2 }}
                  >
                    {room.title}
                  </Typography>

                  {/* Info Row */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <SquareFootIcon fontSize="small" />
                      <Typography variant="body2">{room.size}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PeopleIcon fontSize="small" />
                      <Typography variant="body2">{room.guests}</Typography>
                    </Box>
                  </Box>

                  {/* Bed Info */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <BedIcon fontSize="small" />
                    <Typography variant="body2">{room.bed}</Typography>
                  </Box>

                  {/* Description */}
                  <Typography
                    variant="body2"
                    sx={{ color: '#666', fontSize: '0.95rem', textAlign: 'justify' }}
                  >
                    {room.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Footer Text */}
        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            mt: 6,
            px: 4,
            color: '#555',
            fontSize: '1rem',
          }}
        >
          Each room is designed to harmonize with its natural surroundings while offering
          modern comforts that make your stay truly unforgettable. whether you’re here
          for adventure, relaxation, or a bit of both, your sanctuary at unseen knuckles awaits.
        </Typography>
      </Container>
    </Box>
  );
}

export default Accommodations;
